module.exports = __webpack_public_path__ + "img/thumbnail_rack_frame.af1dddcc.png";